module.exports = __webpack_public_path__ + "img/خلاق.969b6431.jpg";